import useMountEffect from '@restart/hooks/useMountEffect';
import { RiFolderOpenLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import MissionListModal, { PURPOSE } from '@/components/modals/MissionList';
import { ModalService as modal } from '@/libs/Modal';

const Panel = () => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    modal.show(MissionListModal, { purpose: PURPOSE.UPLOAD });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Load';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiFolderOpenLine;
Command.Panel = Panel;

export default Command;
